module.exports = __webpack_public_path__ + "img/setup_light.5b5ef325.jpg";